<template src="./onlineTestBasicDetails.html"></template>

<script>
import showStatus from '../../../NetworkManager/showStatus';
import UploadToDigitalOceanRepository from '../../../Repository/UploadToDigitalOcean';
import apiV3 from "../../../NetworkManager/apiV3";
import DateTimePicker1 from "../../../Components/styleGuide/InputsAndControls/DateTimePickerQuickTest.vue";

export default {
  name: 'onlineTestBasicDetails',
  components: {
    DateTimePicker1
  },
  data() {
    return {
      examName: '',
      descriptionOfExam: '',
      backgroundColor: "#E7E7FFCF",
      rules: {
        required: (value) => !!value || "This field is required",
        totalMarks: (value) => /^\d*$/.test(value) || 'Only numbers are allowed.',
        passingMarks: (value) => /^\d*$/.test(value) || 'Only numbers are allowed.'
      },
      startDateAndTime: '',
      endDateAndTime: '',
      test: {},
      testId: null,
      attachmentFiles: [],
      onlineTestAttachmentLink: null,
      userData: {},
      loading: false,
      attachmentLoading: false,
      isDisabled: false,
      totalMarks: '',
      passingMarks: '',
      showAnswers: false,
      thresholdPercentage: '',
      selectedRadio: null,
      duration: null,
      validationPaased: false,
      selectedObjectTest: null,
      minStartDate: null,
      maxStartDate: null,
      minEndDate: null,
      maxEndDate: null,
      disabledNext: true
    };
  },
  async created() {
    await this.initializeTestDetails();
  },
  async activated() {
      const testDetailsChanged = this.$store.state.liveData.testDetailsChanged;
    if (
      testDetailsChanged.basicDetails ||
      testDetailsChanged.questions ||
      testDetailsChanged.studentAllocation
    ) {
      await this.initializeTestDetails();
    }
  },
  methods: {
    async initializeTestDetails() {
      try {
        this.uploadToDigitalOceanInstance = new UploadToDigitalOceanRepository(this);

        this.selectedDepartment = this.$store.getters["liveData/get_examDepartment"];
        this.selectedCourseYear = this.$store.getters["liveData/get_examCourseYear"];
        this.selectedInstitute = this.$store.getters["instituteData/get_selectedInstitute"];
        this.selectedSemester = this.$store.getters["instituteData/get_selectedSemester"];
        this.selectedObjectTest = this.$store.getters["liveData/get_selectedObjectTest"];
        this.testId = this.$store.getters["liveData/get_testId"];
        this.userData = this.$store.getters["user/get_userData"];

        console.log("this.selectedObjectTest", this.selectedObjectTest);

        if (this.selectedObjectTest?.editTest) {
          const testDate = this.selectedObjectTest?.prop_onlineTest?.dateTimeUTC;
          if (testDate && new Date(testDate) < new Date()) {
            this.isDisabled = true;
          }
          this.disabledNext = false;
          await this.fetchTest();
        }
      } catch (e) {
        console.error("Error during test initialization", e);
      }
    },
    conductionChange() {
      this.startDateAndTime = ''
      this.endDateAndTime = ''
      console.log('this.selectedRadio', this.selectedRadio);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      if (this.selectedRadio === '2') {
        this.minStartDate = null
        this.minEndDate = null
        this.maxStartDate = yesterday.toISOString().split('T')[0];
        this.maxEndDate = yesterday.toISOString().split('T')[0];
      } else {
        this.minStartDate = new Date().toISOString().split('T')[0]
        this.minEndDate = new Date().toISOString().split('T')[0]
        this.maxStartDate = null
        this.maxEndDate = null
      }
      // Emit an event with the current selectedRadio value
      this.$emit('conduction-changed', this.selectedRadio);
    },
    async fetchTest() {
        this.$store.commit("liveData/set_testId", this.selectedObjectTest?.prop_onlineTest?._id);
        this.testId = this.selectedObjectTest?.prop_onlineTest?._id
        this.test = await apiV3.postRequest('/exam/getExamById', { testId: this.testId });
        this.showAnswers = this.test?.data?.showAnswers
        console.log('this.test', this.test);
        this.fillExamData()
    },
    async handleFileInputChange() {
      if (this.attachmentFiles.length > 0) {
        this.attachmentLoading = true;
        this.onlineTestAttachmentLink = await this.uploadFile(this.attachmentFiles);
        this.attachmentLoading = false;
      }
    },
    async goToNextTab() {
      this.$emit('conduction-changed', null, 1);
    },
    async uploadFile(fileArr) {
      try {
        if (fileArr.length > 0) {
          return await this.uploadToDigitalOceanInstance.upload(fileArr, this.userData.uId);
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        return [];
      }
    },
    convertToUTC(input) {
      console.log('inputinput', input.split(" "));
      try {
        // Split the input into date and time with meridian
        const [date, timeWithMeridian] = input.split(' ');
        const [day, month, year] = date.split('-').map(Number);
        const [time] = timeWithMeridian.split(' ');
        let [hours, minutes] = time.split(':').map(Number);
        const meridian = input.split(" ")[input.split(" ").length - 1]
        if (meridian === 'PM' && hours !== 12) {
          hours += 12;
        } else if (meridian === 'AM' && hours === 12) {
          hours = 0;
        }
        const localDate = new Date(year, month - 1, day, hours, minutes);
        return localDate.toISOString();
      } catch (error) {
        return 'Invalid date format';
      }
    },
    formatDateTime(input) {
      try {
        const date = new Date(input);
        if (isNaN(date.getTime())) {
          throw new Error('Invalid date format');
        }

        // Extract local date and time components
        const day = String(date.getDate()).padStart(2, '0'); // Local day
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Local month
        const year = date.getFullYear(); // Local year
        let hours = date.getHours(); // Local hours
        const minutes = String(date.getMinutes()).padStart(2, '0'); // Local minutes
        const meridian = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 24-hour to 12-hour format

        // Format the result
        return `${day}-${month}-${year} ${String(hours).padStart(2, '0')}:${minutes} ${meridian}`;
      } catch (err) {
        return 'Invalid date format';
      }
    },
    ensureISOString(input) {
      console.log('inputinput', typeof input);
        return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(input)
            ? input
            : (() => {
                const [date, time] = input?.split(' ');
                const [day, month, year] = date.split('-').map(Number);
                const [hours, minutes] = time.split(':').map(Number);
                return new Date(year, month - 1, day, hours, minutes).toISOString();
            })();
    },
    async fillExamData() {
      this.examName = this.test?.data?.name;
      this.descriptionOfExam = this.test?.data?.description;
      this.totalMarks = this.test?.data?.totalMarks;
      this.passingMarks = this.test?.data?.passingMarks;
      this.thresholdPercentage = this.test?.data?.thresholdPercentage
      this.startDateAndTime = this.formatDateTime(this.test?.data?.dateTimeUTC)
      this.endDateAndTime = this.formatDateTime(this.test?.data?.endDateAndTime)
      // this.selectedRadio = this.test?.data?.conductingMethod;
      this.duration = this.test?.data?.durationInMins;
      this.attachmentFiles = this.test?.data?.attachmentfile;
      this.selectedRadio = this.test?.data?.conductingMethod === "Backdated" ? '2' : '1';
      this.$emit('conduction-changed', this.selectedRadio);
    },
    async saveBasicDetails() {
      const testDetailsChanged = this.$store.state.liveData.testDetailsChanged;
      testDetailsChanged.basicDetails = true;
      this.$store.commit("liveData/set_testDetailsChanged", testDetailsChanged);
        this.validationPaased = true
        if (this.examName === "") {
            this.validationPaased = false
            showStatus("Please Fill Test Name", 9000, "warning", this);
        } else if (this.totalMarks === "") {
            this.validationPaased = false
            showStatus("Please Fill Total Marks", 9000, "warning", this);
        } else if (this.passingMarks === "") {
            this.validationPaased = false
            showStatus("Please Fill Passing Marks", 9000, "warning", this);
        } else if (Number(this.passingMarks) > Number(this.totalMarks)) {
            this.validationPaased = false
            showStatus("Passing Marks can not be greater than Total Marks", 9000, "warning", this);
        } else if (this.endDateAndTime === "") {
            this.validationPaased = false
            showStatus("End Date and Time is required", 9000, "warning", this);
        } else if (!this.duration) {
            this.validationPaased = false
            showStatus("Duration (in mins) are required", 9000, "warning", this);
        }
        if (this.validationPaased) {
          console.log('this.startDateAndTime', this.startDateAndTime.split(" "));
          this.testId = this.$store.getters["liveData/get_testId"];
          // console.log('this.selectedObjectTest', this.selectedObjectTest);
            const examDetails = {
                // instituteId: this.selectedInstitute,
                semId: this.selectedSemester.semId,
                name: this.examName,
                subjectName: this.selectedObjectTest.prop_selectedSubject.subjectName,
                durationInMins: this.duration,
                subjectId: this.selectedObjectTest.prop_selectedSubject.subjectId,
                facultyId: this.userData.uId,
                passingMarks: this.passingMarks,
                totalMarks: this.totalMarks,
                dateTimeUTC: this.convertToUTC(this.startDateAndTime),
                endDateAndTime: this.convertToUTC(this.endDateAndTime),
                status: "published",
                category: "quick_exam",
                thresholdPercentage: this.thresholdPercentage,
                showAnswers: this.showAnswers
            };
            if (this.selectedRadio) {
              examDetails.conductingMethod = this.selectedRadio === '2' ? "Backdated" : "Upcoming";
            }
            if (this.onlineTestAttachmentLink?.length > 0) {
              examDetails.attachmentfile = this.onlineTestAttachmentLink[0]
            }
            if (this.selectedObjectTest?.prop_selectedDivision) {
                examDetails.division = this.selectedObjectTest.prop_selectedDivision
            }
            if (this.selectedObjectTest?.prop_selectedBatch) {
                examDetails.batch = this.selectedObjectTest.prop_selectedBatch
            }
            if (this.descriptionOfExam !== "") {
                examDetails.description = this.descriptionOfExam;
            }
            try {
                if (this.testId) {
                  console.log('this.selectedObjectTest', this.selectedObjectTest, this.test?.data);
                  examDetails.examId = this.testId
                  // examDetails.dateTimeUTC = typeof this.startDateAndTime === "string" ? this.ensureISOString(this.startDateAndTime) : this.startDateAndTime
                  // examDetails.endDateAndTime = typeof this.endDateAndTime === "string" ? this.ensureISOString(this.endDateAndTime) : this.endDateAndTime
                  const updatedTest = await apiV3.putRequest("/exam/updateTest", examDetails);
                  if (updatedTest) showStatus("Updated basic details successfully", 2000, "success", this);
                  else showStatus("Error in updating basic details", 4000, "error", this);
                } else {
                  const createdTest = await apiV3.postRequest("/exam/create", examDetails);
                  if (createdTest?.test?.insertedId) {
                    this.testId = createdTest?.test?.insertedId
                    this.$store.commit("liveData/set_testId", createdTest?.test?.insertedId);
                    showStatus("Saved successfully", 2000, "success", this);
                    const showTabs = false
                    this.disabledNext = false
                    this.$emit('conduction-changed', null, 0, showTabs);
                  }
                }
                // setTimeout(() => this.gotoQuickTest(), 1200);
            } catch (error) {
                console.error("Error saving exam details:", error);
            }
        }
    }
  }
};
</script>

<style src="./onlineTestBasicDetails.css" scoped></style>
